class SystemStateDocument {
	constructor() {
		this.isLocked = true;
		this.isShutDown = false;
		this.isDesktop = false;
	}
}

export default SystemStateDocument;
